// https://github.com/tldraw/tldraw/blob/5db3c1553e14edd14aa5f7c0fc85fc5efc352335/packages/store/src/lib/executeQuery.ts#L0-L1
// Added stw to ValueMatcher
// stw = starts with
export function objectMatchesQuery(query, object) {
    for (const [key, _matcher] of Object.entries(query)){
        const matcher = _matcher;
        const value = object[key];
        // if you add matching logic here, make sure you also update executeQuery,
        // where initial data is pulled out of the indexes, since that requires different
        // matching logic
        if ("eq" in matcher && value !== matcher.eq) return false;
        if ("neq" in matcher && value === matcher.neq) return false;
        if ("hasProperty" in matcher && !(key in object)) return false;
        if ("gt" in matcher && (typeof value !== "number" || value <= matcher.gt)) return false;
        if ("stw" in matcher && (typeof value === "number" || typeof value === "string") && !value.toString().startsWith(matcher.stw.toString())) return false;
        // TODO: Fix the typing here but the logic is correct!
        // @ts-ignore
        if ("in" in matcher && !matcher.in.includes(value)) return false;
        if ("inStw" in matcher) {
            if (typeof value !== "string" && typeof value !== "number") return false;
            const valueString = value.toString();
            // @ts-ignore
            if (!matcher.inStw.some((s)=>valueString.startsWith(s))) return false;
        }
    }
    return true;
}
